export default __webpack_public_path__ + "static/media/favicon_netzebw.5df5926c.ico";